<template>
  <transition name="fade">
    <div v-if="filteredTasks.length" class="task-field">
      <p class="task-field__title">Задачи планирования:</p>

      <p v-for="task in filteredTasks" :key="task.id">- {{ task.name }}</p>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'TaskField',
  props: {
    addParams: {
      type: Object,
      default: () => ({}),
    },
    formContext: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    tasks() {
      return this.addParams?.maximum?.tasks ?? []
    },
    relations() {
      return this.addParams?.maximum?.relations ?? []
    },
    taskById() {
      return this.tasks.reduce((map, task) => {
        map[task.id] = task
        return map
      }, {})
    },
    taskIndexes() {
      return this.relations.reduce(
        (indexes, relation) => {
          const { taskId, employeeId, partnerId } = relation

          if (employeeId != null && partnerId != null) {
            this.addToIndex(indexes.byPair, this.makePairKey(employeeId, partnerId), taskId)
          }

          this.addToIndex(indexes.byEmployee, employeeId, taskId)
          this.addToIndex(indexes.byPartner, partnerId, taskId)

          return indexes
        },
        {
          byPair: {},
          byEmployee: {},
          byPartner: {},
        }
      )
    },
    filteredTasks() {
      const { employee, partner } = this.formContext ?? {}

      let taskIds = []

      if (employee != null && partner != null) {
        const key = this.makePairKey(employee, partner)

        taskIds = this.taskIndexes.byPair[key] ?? []
      } else if (employee != null) {
        taskIds = this.taskIndexes.byEmployee[employee] ?? []
      } else if (partner != null) {
        taskIds = this.taskIndexes.byPartner[partner] ?? []
      }

      return [...taskIds].map(taskId => this.taskById[taskId]).filter(Boolean)
    },
  },
  methods: {
    makePairKey(employeeId, partnerId) {
      return `${employeeId}_${partnerId}`
    },
    addToIndex(index, key, taskId) {
      if (key == null) {
        return
      }

      if (!index[key]) {
        index[key] = new Set()
      }

      index[key].add(taskId)
    },
  },
}
</script>

<style lang="sass">
@import "~@src/legacy/sass/params"

.task-field
  padding: 16px
  background-color: $gray
  border-radius: 3px
  margin-bottom: 16px

  &__title
    margin-bottom: 8px
</style>



// WEBPACK FOOTER //
// src/modules/shared/ui/public/forms/fields/TaskField.vue